var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$utils.isMobile() ? 'cpt-divider-m' : 'cpt-divider',style:({background: _vm.type == 1 ? 'rgba(255, 255, 255, 1)' : 'rgba(51, 51, 51, 0.3)'})},[_c('div',{staticClass:"divider",style:({background: _vm.type == 1 ? '#fff' : '#407ea0)'})})])
}
var staticRenderFns = []

export { render, staticRenderFns }